import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Paper, Typography, Divider, Grid, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik } from "formik";
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import pickBy from "lodash/pickBy";
import identity from "lodash/identity";


import Layout from "../../../components/layout/Layout";
import Switch from "../../../components/form/Switch";
import InputText from "../../../components/form/InputText";
import InputTextDetail from "../../../components/form/InputTextDetail";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Skeleton from "../../../components/form/Skeleton";
import validator from "./validator";

import { getZoneId } from "../../../store/masters/thunk/zone/getId";
import { putZone } from "../../../store/masters/thunk/zone/put";

const NewEdit = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("zone");
    const { id } = useParams();
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "put" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })

    const user = useSelector(state => state.auth.login.dataUser);
    const put = useSelector((state) => state.masters.zone.put);
    const current = useSelector(state => state.masters.zone.detail);

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                type: "default",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    useEffect(() => {
        if (get(put, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "put" });}
        if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
    }, [put])

    useEffect(() => {
        if (!!id) {
            dispatch(getZoneId({ id }))
        }
    }, [dispatch, id])

    const onSubmit = (values) => {
        const idZone = id; // Asumes que siempre tienes un ID
        const whitOutNulls = pickBy(values, identity); // Filtras los valores nulos o vacíos
    
        if (idZone) {
            dispatch(putZone({ idZone, ...whitOutNulls }));
        }
    }

    const initialValues = {
        isActive: id ? get(current, "data.isActive", "") :  true,
        description: id ? get(current, "data.description", "") : "",
        idUser: get(user, "idUser"),
    }

    return (
        <Layout
            propsToolbar={{
                title: !id ? __(`head.new.name`) : __(`head.edit.name`),
                srute: !id ? __(`head.new.code`) : id
            }}
        >
            {get(current, "isLoading")
                ? (
                <Skeleton /> 
            ) : ( 
                <Formik initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
                    {formik => (
                        <form onSubmit={get(formik, "handleSubmit")}>
                            <Paper className='p-4'>
                                <Stack direction="row" spacing={2} justifyContent="flex-end">
                                    <LoadingButton className='w-[100px] min-w-[100px]' variant="contained" color="secondary" type="submit" loading={get(put, "isLoading")}>{__(`action.save`)}</LoadingButton>
                                    <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary" onClick={() => navigate("/masters/zones")} disabled={get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                                </Stack>
                            </Paper>
                            <Paper className='mt-4'>
                                <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                    <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                    <Switch formik={formik} name="isActive" __={__} />
                                </Stack>
                                <Divider />
                                <Box className='p-4' >
                                    <Grid container spacing={{ xs: 2, md: 3 }}>
                                        <Grid item xs={12} sm={6} >
                                            <InputText
                                                formik={formik}
                                                name="description"
                                                label={__(`form.description.label`)}
                                                placeholder={__(`form.description.placeholder`)}
                                                disabled={get(put, "isLoading", false)}
                                                multiline
                                                rows={3}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Paper>
                        </form>
                    )}
                </Formik>
            )}
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </Layout>
    )
}

export default NewEdit